import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { FaBars, FaChevronDown } from "react-icons/fa";
import logo from "../../assets/images/logo.webp";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [serviceOpen, setServiceOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const vendorRegister = (e) => {
    e.preventDefault();
    setShowModal(true);
  };

  const closeModal = () => setShowModal(false);
  return (
    <>
      <header className="site-header-menu-inner cmt-stickable-header">
        <div className="container">
          <div className="site-navigation d-flex align-items-center justify-content-between">
            {/* LOGO */}

            <NavLink to="/" className="site_logo">
              <img src={logo} className="logo" />
            </NavLink>

            <span
              className={` menubar-box btn-show-menu-mobile menubar ${
                menuOpen ? "is-active" : ""
              }`}
              onClick={() => setMenuOpen(!menuOpen)}
            >
              <FaBars className="menubar-inner" />
            </span>

            {/* MAIN MENU */}
            <nav className={`main-menu ${menuOpen ? "show" : ""}`}>
              <ul className="menu">
                <li className="mega-menu-item">
                  <NavLink
                    to="/"
                    onClick={() => setMenuOpen(false)}
                    className={({ isActive }) =>
                      isActive ? "menu-link active" : "menu-link"
                    }
                  >
                    Home
                  </NavLink>
                </li>

                <li className="mega-menu-item">
                  <NavLink
                    to="/about-us"
                    onClick={() => setMenuOpen(false)}
                    className={({ isActive }) =>
                      isActive ? "menu-link active" : "menu-link"
                    }
                  >
                    About Us
                  </NavLink>
                </li>

                {/* SERVICES DROPDOWN */}
                <li className={`mega-menu-item`}>
                  <NavLink
                    to="/services"
                    onClick={() => setMenuOpen(false)}
                    className={({ isActive }) =>
                      isActive ? "menu-link active" : "menu-link"
                    }
                  >
                    Services
                    {/* <FaChevronDown /> */}
                  </NavLink>

                  {/* <ul className={`mega-submenu ${serviceOpen ? "active" : ""}`}>
                    <li>
                      <NavLink to="/air-quality">Air Quality Testing</NavLink>
                    </li>
                    <li>
                      <NavLink to="/maintenance">Maintenance & Repair</NavLink>
                    </li>
                    <li>
                      <NavLink to="/cooling">Cooling Services</NavLink>
                    </li>
                    <li>
                      <NavLink to="/coil-cleaning">Coil Cleaning</NavLink>
                    </li>
                  </ul> */}
                </li>

                <li className="mega-menu-item">
                  <NavLink
                    to="/contact-us"
                    onClick={() => setMenuOpen(false)}
                    className={({ isActive }) =>
                      isActive ? "menu-link active" : "menu-link"
                    }
                  >
                    Contact Us
                  </NavLink>
                </li>
              </ul>
            </nav>

            {/* RIGHT BUTTON */}
            <div className="header_extra header_btn">
              {/* <Link onClick={vendorRegister} className="primary_btn btn btn-primary">
                Vendor Registration
              </Link> */}

              <NavLink to="/" className="primary_btn btn btn-primary">
                Customer Registration
              </NavLink>

              <NavLink to="/" className="primary_btn btn btn-primary">
                Vendor Registration
              </NavLink>

            </div>
          </div>
        </div>
      </header>

      {showModal && (
        <>
          <div className="modal fade show d-block" tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">

                <div className="modal-header bg_primary text-light">
                  <h4 className="modal-title">Vendor Registration</h4>
                  <button
                    type="button"
                    className="btn-close invert"
                    onClick={closeModal}
                  ></button>
                </div>

                <div className="modal-body">
                  <form>
                    <div className="row">
                      <div className="col-md-12 mb-3">
                        <label className="form-label">Vendor Name</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter name"
                        />
                      </div>

                      <div className="col-md-12 mb-3">
                        <label className="form-label">Service Type</label>
                        <select className="form-select">
                          <option>Select Service</option>
                          <option>Plumbing</option>
                          <option>Electrical</option>
                          <option>Cleaning</option>
                          <option>Security</option>
                        </select>
                      </div>

                      <div className="col-md-12 mb-3">
                        <label className="form-label">Mobile Number</label>
                        <input
                          type="text"
                          className="form-control"
                          maxLength={10}
                          placeholder="Enter phone"
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(
                              /[^0-9]/g,
                              ""
                            );
                          }}
                        />
                      </div>

                      <div className="col-md-12 mb-3">
                        <label className="form-label">City</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter city"
                        />
                      </div>
                    </div>
                  </form>
                </div>

                <div className="modal-footer justify-content-center">
                  <button className="primary_btn btn btn-primary">
                    Submit Now
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-backdrop fade show"></div>
        </>
      )}
    </>
  );
};

export default Header;
